import React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  styled,
  CircularProgress,
  DialogActions,
  Grid,
  Paper,
} from "@mui/material";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
    // maxWidth: "350px",
  },
}));

const ModalNeop = ({ open, onClose, candidateNeop, loadingModal }) => {
  useTheme();

  const handleStart = (auth) => {
    const newWindow = window.open(
      `${window.location.origin}/entrance/pages/login?email=${auth.user_id}&password=${auth.password}&ecommerceUrl=${window.location.hostname}`,
      "_self",
      "noopener,noreferrer",
    );
    if (newWindow) newWindow.opener = null;
  };

  if (loadingModal) return <CircularProgress />;

  return (
    <CustomDialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>
        <b>NEOP</b>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">{candidateNeop[0]?.publish_g_name}</Typography>
        {candidateNeop.map((cn) => (
          <Paper sx={{ p: "0.5rem 1rem" }}>
            <Grid container>
              <Grid item xs={5} sx={{ m: "auto" }} variant="body2">
                <Typography>{cn.publish_name}</Typography>
              </Grid>
              <Grid item xs={5} sx={{ m: "auto" }}>
                <Typography variant="body2" sx={{ fontSize: "12px" }}>
                  {cn?.auth?.tgl_mulai} - {cn?.auth?.tgl_selesai}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  disabled={!cn?.auth?.is_active || cn?.auth?.is_finished}
                  onClick={() => handleStart(cn.auth)}
                >
                  {cn?.auth?.is_finished ? "Selesai" : "Mulai"}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Tutup</Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ModalNeop;
